const menu = [
  {
    id: 1,
    link: 'https://github.com/Acknowledge-App/Acknowledge',
    title: 'Acknowledge',
    category: 'React',
    img: './images/1.png',
    desc: `Acknowledge is an app to save your achievements over your day. A lot of achievements that we make day to day are usually lost in the noise of our busy lives; sometimes small, sometimes intangible but Acknowledge seeks to change that. With Acknowledge you can record your day to day achievements and place where they fit into your lives.`,
  },
  {
    id: 2,
    link: 'http://mnemonic-game.herokuapp.com/',
    title: 'mnemonic',
    category: 'React',
    img: './images/mnemonic.png',
    desc: `A single-page web app game, based on the classic memory / matching cards game.`,
  },
  {
    id: 3,
    link: 'https://github.com/Peter2-71828/aceBook-PingPong',
    title: 'aceBook-PingPong',
    category: 'Ruby on Rails',
    img: './images/AceBook.png',
    desc: `A recreation of Facebook Using Ruby on rail. Features include Creating posts, updating, edit and delete posts.Along with having a profile and a profile picture.`,
  },
  {
    id: 4,
    link: 'https://github.com/Ovy95/Thermostat',
    title: 'Thermostat',
    category: 'JavaScript',
    img: './images/Thermostat.png',
    desc: `This was our first JavaScript project at Makers. It was to create the logic for a thermostat in Js being able to interact with it increasing and decreasing the temperature. This included having a min and max temperature as well as power-saving modes which would also restrict temperatures. Along with this, there is a Weather app Api which by default gets the current temperature in London, this can be changed by using the search box to enter in another location to get the temperature of that location.`,
  },
  {
    id: 5,
    link: 'https://github.com/Ovy95/Gilded-rose-tech-test',
    title: 'Gilded Rose tech test',
    category: 'JavaScript',
    img: `./images/GildedRose.jpeg`,
    desc: `The gilded-rose kata is designed to practice rescuing legacy code safely by writing a robust characterisation test, refactoring the code into well-designed units, and then backfilling those units with more focused tests. Along the ability to implement new features.`,
  },
  {
    id: 6,
    link: 'https://github.com/Ovy95/Portfolio',
    title: 'Portfolio',
    category: 'React',
    img: './images/Portfolio.png',
    desc: `This is what your currently using at the moment. This is a react project to help me show of my projects. Also to upskill knowledge of using React.`,
  },
  {
    id: 7,
    title: 'SportsBot',
    category: 'Python',
    img: './images/SportsBot.png',
    desc: `A discord bot used to return football fixtures results and live scores using a Api. Also can check the lineups and subs bench for next teams to play 30 minutes before kickoff `,
  },
  {
    id: 8,
    title: 'Realtime Chat-Application',
    link: 'https://github.com/Ovy95/Chat-Application-Go-React',
    category: 'Golang',
    img: './images/Chatapplication.png',
    desc: `Realtime chat application built to understand Websockets with Go`,
  },
  {
    id: 9,
    link: 'https://github.com/Ovy95/Bank_tec_TestJS',
    title: 'Bank tech test',
    category: 'JavaScript',
    img: './images/BankTecTest.png',
    desc: `Having attempted this in Ruby and not being able to solve the problem during my time at Makers. I decided to attempt this again in JavaScript to help grow my process better. The task is to create a bank app to the specifications listed in the Requirements Section.`,
  },
];
export default menu;
